<section class="about-section fade-up" #aboutSection>
<div class="about-content">
        <h1>¿Qué es Tadic List?</h1>
        <div class="col-12">
            <p>
                Tadic List es una plataforma diferente. No tenemos intermediarios.
            </p>
        </div>
        <div class="col-12 text-center align-items-center justify-content-center">
            <button pButton pRipple type="button">
                <span class="px-4">Explorar más</span>
                <i class="pi pi-arrow-right custom-arrow-right-icon"></i>
            </button>
        </div>
    </div>

    <div class="about-images">
        <img class="image image-1" [src]="'assets/layout/images/home/' + leftImages[0].filename" alt="Image 1">
        <img class="image image-2" [src]="'assets/layout/images/home/' + leftImages[1].filename" alt="Image 2">
    </div>
</section>
